import { FC } from 'react';
import { AdElementText, AdTemplate } from '@adflow/types';
import { Flex, HStack, Heading } from '@chakra-ui/react';
import DynamicFontSizeControls from './DynamicFontSizeControls';
import TextCaseControls from './TextCaseControls';
import TextAlignmentControls from './TextAlignmentControls';
import LineHeightInput from './LineHeightInput';
import FontSizeInput from './FontSizeInput';
import FontSelectionControls from './FontSelectionControls';
import DynamicContentTemplateInput from '../DynamicContentTemplateInput';
import DateTimeControls, { isDateTimePresent } from './DateTimeControls';
import OddsControls, { isOddsPresent } from './OddsControls/OddsControls';
import PenaltiesFormatControls, {
  isMatchStatusPresent,
} from './PenaltiesFormatControls/PenaltiesFormatControls';
import XPositionInput from './XPositionInput';
import YPositionInput from './YPositionInput';

type Props = {
  selectedElement: AdElementText;
  importSourceType: AdTemplate['importSourceType'];
};

const TextElementControls: FC<Props> = ({ selectedElement, importSourceType }) => {
  return (
    <Flex direction="column">
      <DynamicContentTemplateInput selectedElement={selectedElement} />
      {/* Fonts and Typography are not used in creatomate templates */}
      {importSourceType !== 'creatomate' && (
        <>
          <DynamicFontSizeControls textElement={selectedElement} />
          <Heading fontSize="lg" fontWeight="semibold" mt="7" noOfLines={1}>
            Typography
          </Heading>
          <HStack spacing="24px" mt={5}>
            <TextAlignmentControls selectedElement={selectedElement} />
            <FontSizeInput selectedElement={selectedElement} />
            <LineHeightInput selectedElement={selectedElement} />
          </HStack>
          <HStack spacing="24px" mt={5}>
            <XPositionInput selectedElement={selectedElement} />
            <YPositionInput selectedElement={selectedElement} />
          </HStack>
          <FontSelectionControls selectedElement={selectedElement} />
          <TextCaseControls selectedElement={selectedElement} />
        </>
      )}
      {isDateTimePresent(selectedElement) && (
        <DateTimeControls selectedElement={selectedElement} importSourceType={importSourceType} />
      )}
      {importSourceType !== 'creatomate' && isOddsPresent(selectedElement) && (
        <OddsControls selectedElement={selectedElement} />
      )}
      {importSourceType !== 'creatomate' && isMatchStatusPresent(selectedElement) && (
        <PenaltiesFormatControls selectedElement={selectedElement} />
      )}
    </Flex>
  );
};

TextElementControls.displayName = 'TextElementControls';

export default TextElementControls;
